import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to set the canonical URL for the current page
 * Always uses https://ablex.bz as the base domain
 * Query parameters like ?lang=xx are NOT included in the canonical
 */
export const useCanonical = () => {
    const location = useLocation();

    useEffect(() => {
        // Get the pathname without trailing slash (except for home page)
        const pathname = location.pathname === '/' ? '/' : location.pathname.replace(/\/$/, '');
        
        // Build canonical URL - always use https://ablex.bz
        // Do NOT include query parameters like ?lang=xx
        const canonicalUrl = `https://ablex.bz${pathname}`;
        
        // Update the canonical link
        let link = document.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement('link');
            link.rel = 'canonical';
            document.head.appendChild(link);
        }
        link.href = canonicalUrl;
        
    }, [location.pathname]);
};
